import {BusinessRegistrationContent} from 'components/Business/Registration/RegistrationContent';

export const BusinessRegistration = () => {
    return <BusinessRegistrationContent />;
};
